export const isLoggedAction = (type, bool) => {
    return{
        type: type,
        bool: bool
    }
}